import { render, staticRenderFns } from "./List-Shipment-Detail.vue?vue&type=template&id=7e9ec730&scoped=true"
import script from "./List-Shipment-Detail.vue?vue&type=script&lang=js"
export * from "./List-Shipment-Detail.vue?vue&type=script&lang=js"
import style0 from "./List-Shipment-Detail.vue?vue&type=style&index=0&id=7e9ec730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9ec730",
  null
  
)

export default component.exports